/**
 * Format bytes to human-readable string
 * @param {number} bytes - Bytes to format
 * @returns {string} - Formatted string (e.g., "1.5 MB")
 */
export function formatBytes(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Format upload speed to human-readable string
 * @param {number} bytesPerSecond - Bytes per second
 * @returns {string} - Formatted string (e.g., "1.5 MB/s")
 */
export function formatSpeed(bytesPerSecond) {
  if (bytesPerSecond === 0) return '0 B/s';
  const k = 1024;
  const sizes = ['B/s', 'KB/s', 'MB/s', 'GB/s'];
  const i = Math.floor(Math.log(bytesPerSecond) / Math.log(k));
  return Math.round((bytesPerSecond / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Calculate upload progress percentage
 * @param {number} uploadedBytes - Bytes uploaded
 * @param {number} fileSize - Total file size
 * @returns {number} - Progress percentage (0-100)
 */
export function getProgress(uploadedBytes, fileSize) {
  if (fileSize === 0) return 0;
  return Math.round((uploadedBytes / fileSize) * 100);
}

/**
 * Get status display text
 * @param {string} status - Upload status
 * @param {function} t - Translation function (optional)
 * @returns {string} - Human-readable status text
 */
export function getStatusDisplayText(status, t = null) {
  if (status === 'ready') {
    return t ? t('readyForUploading') : 'ready for uploading';
  }
  
  // Translate status if translation function is provided
  if (t) {
    const statusMap = {
      'initializing': t('initializing'),
      'ready': t('ready'),
      'queued': t('queued'),
      'uploading': t('uploadingStatus'),
      'paused': t('paused'),
      'completed': t('completed'),
      'cancelled': t('cancelled'),
      'error': t('error'),
    };
    return statusMap[status] || status;
  }
  
  return status;
}

